<script setup>
  import { ref, getCurrentInstance, onMounted, watch } from 'vue'
  import { useRouter, useRoute } from 'vue-router';
  import { usePageLoadingStore } from '../../../../stores/pageLoading';
  import { useUserStore } from '../../stores/user';
  import { useNavigationStore } from '../../../../stores/navigation';
  import { storeToRefs } from "pinia";
  import JobFairJobNoticeDetailModal from '../../components/modal/jobFair/JobFairJobNoticeDetailModal.vue';
  import KSATextButtonStop from '../../../../components/ui-components/button/KSATextButtonStop.vue';
  import mypageJobFairService from '../../services/mypage/jobFair/mypageJobFairService';
  import mypageJobFairJobNoticeService from '../../services/mypage/jobFair/mypageJobFairJobNoticeService';
  
  const loadingStore = usePageLoadingStore();
  const userStore = useUserStore();
  const navigationStore = useNavigationStore()

  const { user, isAuthenticated } = storeToRefs(userStore);
  const globals = getCurrentInstance().appContext.config.globalProperties;
  const { alert, confirm, $pageListBoardNo, $yyyymmdd, $gbNameKR } = globals;

  const router = useRouter();
  const route = useRoute();

  const interestsOptions = ref(globals.$interests ? globals.$interests.map(item => ({ ...item })) : []);
  const desiredJobOptions = ref(globals.$desiredJob ? globals.$desiredJob.map(item => ({ ...item })) : []);
  const jobExperienceOptions = ref(globals.$jobExperience ? globals.$jobExperience.map(item => ({ ...item })) : []);
  const workTypeOptions = ref(globals.$workType ? globals.$workType.map(item => ({ ...item })) : []);
  const schoolGbOptions = ref(globals.$schoolGb ? globals.$schoolGb.map(item => ({ ...item })) : []);

  const searchOpen = ref(true);

  const interestGbRef = ref(null);
  const desiredJobGbRef = ref(null);
  const jobExperienceRef = ref(null);
  const schoolGbRef = ref(null);
  const workTypeRef = ref(null);
  const workAreaRef = ref(null);

  const initialSearchInput = {
    interests: interestsOptions.value.map(item => item.value),
    desiredJobs: desiredJobOptions.value.map(item => item.value),
    jobExperiences: jobExperienceOptions.value.map(item => item.value),
    schoolGbs: schoolGbOptions.value.map(item => item.value),
    workTypes: workTypeOptions.value.map(item => item.value),
    workArea1: '',
    workArea2: '',
  };
  const searchInput = ref({ ...initialSearchInput });

  const currentPage = ref(1);
  const pageSize = ref(20);
  const totalPages = ref(0);
  const totalCount = ref(0);

  const jobNoticeModal = ref(null);

  const list = ref([]);

  const jobOrderByList = [
    { label: '최근 등록순', value: 'createDate DESC'},
    { label: '최근 수정순', value: 'modifyDate DESC'},
  ];

  const pageSizeGroup = ref([
    { label:"20개씩 보기", value: "20" },
    { label:"40개씩 보기", value: "40" },
    { label:"60개씩 보기", value: "60" },
    { label:"80개씩 보기", value: "80" },
    { label:"100개씩 보기", value: "100" },
  ]);

  const loaded = ref(false);

  const onSelectedJobArea1Option = (option) => {
    searchInput.value.workArea1 = option === '시/도 선택' ? '' : option;
  };

  const onSelectedJobArea2Option = (option) => {
    searchInput.value.workArea2 = option === '시/구/군 선택' ? '' : option;
  };

  const clearSearch = () => {
    Object.assign(searchInput.value, initialSearchInput);

     if (interestGbRef.value && interestGbRef.value.initOptions) {
      interestGbRef.value.initOptions();
    }
    if (desiredJobGbRef.value && desiredJobGbRef.value.initOptions) {
      desiredJobGbRef.value.initOptions();
    }
    if (jobExperienceRef.value && jobExperienceRef.value.initOptions) {
      jobExperienceRef.value.initOptions();
    }
    if (schoolGbRef.value && schoolGbRef.value.initOptions) {
      schoolGbRef.value.initOptions();
    }
    if (workTypeRef.value && workTypeRef.value.initOptions) {
      workTypeRef.value.initOptions();
    }
    if(workAreaRef.value && workAreaRef.value.initSelectedOption) {
      workAreaRef.value.initSelectedOption('', '');
    }
  };

  const onClickSearch = () => {
    currentPage.value = 1;
    retrieveList();
  };

  const regTermOptions = ref([
    { label: '전체', value: '' },
    { label: '채용대기', value: '01' },
    { label: '채용중', value: '02' },
    { label: '채용마감', value: '03' },
  ]);

  const selectedRegTerm = ref(regTermOptions.value[0] ? regTermOptions.value[0].value : '');

  const onChangeRegTerm = (tab) => {
    selectedRegTerm.value = tab.value;
    currentPage.value = 1;
    retrieveList();
  };

  const retrieveList = () => {
    const params = {
      jobNoticeStateGbs: selectedRegTerm.value || "", // 전체 : "", 채용대기: "01",  채용중: "02",  채용마감: "03"
      searchInterests: searchInput?.value.interests?.join(',') || "", // "설계,장비,소재,제조공정,패키지,테스트,SW,기타",
      searchJob: searchInput?.value.desiredJobs?.join(',') || "", // "회로/시스템 설계,장비 운영/유지보수/개선,장비/부품 개발,소재 개발 및 평가,공정 개발 및 평가,패키지 개발,제품 평가 및 분석,반도체 SW개발,기타",
      searchJobExperience: searchInput?.value.jobExperiences?.join(',') || "", // "신입,경력,경력무관",
      searchSchoolGbs: searchInput?.value.schoolGbs?.join(',') || "", // "01,02,03,04,05",
      searchWorkType: searchInput?.value.workTypes?.join(',') || "", // "정규직,계약직,인턴,프리랜서",
      searchWorkAreas: `${searchInput?.value.workArea1 || ''}${searchInput?.value.workArea1 ? ' ' : ''}${searchInput?.value.workArea2 || ''}`,
      pageNumber: currentPage.value,
      size: pageSize.value,
      userId: user.userId,
      orderProperty: searchInput.value.orderProperty,
      orderDirection: searchInput.value.orderDirection,
    };

    loadingStore.loading = true;
    mypageJobFairJobNoticeService.retrieveAllJobNoticePaging(params)
      .then(res => {
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          list.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
        }
        loadingStore.loading = false;
      })
      .catch( (error) =>  {
        loadingStore.loading = false;
      });
  };

  const onSelectPage = (pageNo) => {
    currentPage.value = pageNo;
    retrieveList();
  };

  const onSelectPageSize = (option) => {
    pageSize.value = option.value;
    currentPage.value = 1;
    retrieveList();
  };

  // 정렬 셀렉트 박스 선택
  const onSelectOrderBy = (option) => {
    loadingStore.loading = true;
    const [orderProperty, orderDirection] = option.value.split(" ");
    currentPage.value = 1;
    searchInput.value.orderProperty = orderProperty;
    searchInput.value.orderDirection = orderDirection;
    retrieveList();
  };

  const formatJob = (job) => {
    if (!job) return '';
    const jobs = job.split(',');
    if (jobs.length > 1) {
      return `${jobs[0]} 외 ${jobs.length - 1}개`;
    }
    return job;
  };

  // 채용공고 등록
  const onClickEntryCompany = async () => {
    if(!isAuthenticated.value) {
      alert("로그인 후 이용해주세요.");
      navigationStore.lastAccessPage = route.fullPath;
      router.push({name: 'Signin'});
    } else {
      if ((user.value.userGb === 'COMPANY' && user.value.userInfo?.corpMasterYn === 'Y')) {
        const corpId = user.value.userInfo.corporation.corpId;

        // 기업 채용공고 등록 시 기업정보 등록 및 정보제공동의여부 확인
        mypageJobFairService.retrieveRecruitPrivacyAgreeYnByCorpId(corpId)
          .then( async (res) => {
            loaded.value = true;
            if(res.data.code.toLowerCase() === 'success') {
              const result = res.data.result;

              if (result !== 'Y') {  // 기업정보 및 정보제공동의여부 내역 없을 때
                const ok = await alert(["등록된 기업정보가 없습니다.", "기업정보 등록 후 채용공고 등록이 가능합니다."]);
                router.push({ name: 'MyPageCorpInfoCreate' });
              } else {
                router.push({ name: 'MyPageCorpJobNoticeCreate' });
              }
            }
          })
          .catch( (error) =>  {
            loaded.value = true;
          });
      } else {
        alert(["재직자/기업 마스터 회원만", "채용공고 등록이 가능합니다."]);
      }
    }
  }

  // 채용공고 보기
  const onClickJobNotice = async (item) => {
    if(!isAuthenticated.value) {
      alert("로그인 후 이용해주세요.");
      navigationStore.lastAccessPage = route.fullPath;
      router.push({name: 'Signin'});
      return;
    }

    // console.log(item);
    const result = await jobNoticeModal.value.show({
      jobNoticeSeq: item.jobNoticeSeq,
      corpId: item.corpId,
      inteYn: item.interestNoticeYn
    });

    if(result && result.interestNoticeYn) {
      item.interestNoticeYn = result.interestNoticeYn;
    }
  }

  // 관심 공고 관심여부
  const onClickInterestNotice = async (item) => {
    const inteYn = item.interestNoticeYn === 'Y' ? 'N' : 'Y';
    const inteYnName = inteYn === 'Y' ? '등록' : '삭제';

    const ok = await confirm([`관심공고${inteYn === 'Y' ? '로 ' : '를 '}${inteYnName}하시겠습니까?`], `관심공고 ${inteYnName}`, "취소");
    if(ok) {
      let paramObj = {
        userId: user.value.userId,
        jobNoticeSeq: item.jobNoticeSeq,
        interestNoticeYn: inteYn,
      }
      item.interestNoticeYn = inteYn;

      mypageJobFairService.updateInterestNoticeYn(paramObj)
        .then((res) => {
          if(res.data.code.toLowerCase() === 'success') {
            alert([`${inteYnName}하였습니다.`]);
          } else {
            alert([`${inteYnName} 실패하였습니다.`]);
          }
        })
        .catch( (res) =>  {
          alert([`${inteYnName} 실패하였습니다.`]);
        });
    }
  }

  onMounted(() => {
    retrieveList();
  });
</script>

<template>
  <div>
    <div class="process-wrap matching">
      <h4>채용공고 등록 및 제안하기</h4>
      <div class="process-layout">
        <div class="process-steps-scroll">
          <ul>
            <li>- ‘채용공고’ 등록을 통해 기업 맞춤형 디스플레이 인재를 찾아보세요.</li>
            <li>- ‘인재정보‘ 를 확인하고 기업에 딱 맞는 인재에게 면접 제안을 해보세요.</li>
          </ul>
          <div class="process-steps">
            <div class="step"><div>채용공고<br>등록</div></div>
            <div class="step-arrow"><div></div></div>
            <div class="step"><div>인재 정보<br>검색/제안</div></div>
            <div class="step-arrow"><div></div></div>
            <div class="step"><div>면접제안<br>확인/수락</div></div>
            <div class="step-arrow"><div></div></div>
            <div class="step"><div>매칭 완료</div></div>
            <div class="step-arrow active"><div></div></div>
            <div class="step large active"><div>기업별<br>채용 전형 진행</div></div>
          </div>
        </div>
        <div class="button-with-info">
          <p>채용공고 등록 및 제안을 통해<br>맞춤형 인재를 찾아보세요.</p>
          <div class="button-with-info-cta" @click="onClickEntryCompany()">채용공고 등록하기<span class="icon-button-right"></span></div>
        </div>
      </div>
    </div>
    <div class="lecture-wrap">
      <KSATab class="tab-style_small" :options="regTermOptions" @change="onChangeRegTerm"/>
      <div class="filter-wrap" :class="{'open': searchOpen}">
          <p @click="searchOpen = !searchOpen">검색</p>
          <div class="filter">
              <dl>
                  <dt>관심 카테고리</dt>
                  <dd>
                      <KSACheckBoxGroup
                          ref="interestGbRef"
                          className="mr-md"
                          name="interests"
                          v-model="searchInput.interests"
                          :options="interestsOptions" />
                  </dd>
              </dl>
              <dl>
                  <dt>직무</dt>
                  <dd class="majorGb">
                      <KSACheckBoxGroup
                          ref="desiredJobGbRef"
                          className="mr-md"
                          name="desiredJobs"
                          v-model="searchInput.desiredJobs"
                          :options="desiredJobOptions" />
                  </dd>
              </dl>
              <dl>
                  <dt>경력</dt>
                  <dd>
                      <KSACheckBoxGroup
                          ref="jobExperienceRef"
                          className="mr-md"
                          name="jobExperiences"
                          v-model="searchInput.jobExperiences"
                          :options="jobExperienceOptions" />
                  </dd>
              </dl>
              <dl>
                  <dt>학력</dt>
                  <dd>
                      <KSACheckBoxGroup
                          ref="schoolGbRef"
                          className="mr-md"
                          name="schoolGbs"
                          v-model="searchInput.schoolGbs"
                          :options="schoolGbOptions" />
                  </dd>
              </dl>
              <dl>
                  <dt>근무형태</dt>
                  <dd>
                      <KSACheckBoxGroup
                          ref="workTypeRef"
                          className="mr-md"
                          name="workTypes"
                          v-model="searchInput.workTypes"
                          :options="workTypeOptions" />
                  </dd>
              </dl>
              <dl>
                  <dt>근무지역</dt>
                  <dd>
                      <KSASelectResidenceArea
                          class="select"
                          ref="workAreaRef"
                          @selectOption1="onSelectedJobArea1Option"
                          @selectOption2="onSelectedJobArea2Option"
                      />
                  </dd>
              </dl>
              <div class="btn-wrap">
                  <KSASecondaryButton class="gray_button" text="초기화" @click="clearSearch" />
                  <KSAPrimaryButton text="검색" @click="onClickSearch" />
              </div>
          </div>
      </div>
      <!-- e: 검색 -->
      <div class="list-top">
        <p>채용공고 <span>{{ $number(totalCount)}}</span>개</p>
        <div class="grid">
          <KSASelect
            ref="searchOrderByRef"
            :options="jobOrderByList"
            class="select"
            @selectOption="onSelectOrderBy"
          />
          <KSASelect
            ref="searchPageSizeRef"
            :options="pageSizeGroup"
            class="select ml-xs"
            @selectOption="onSelectPageSize"
          />
        </div>
      </div>
      <div v-if="list.length > 0">
        <div class="corp-wrap">
          <dl v-for="corp in list" @click="onClickJobNotice(corp)">
            <dt>
              <KSAImage :src="corp.ciImgDir"/>
            </dt>
            <dd>
              <p class="text-over">{{ corp.corpName }}</p>
              <h1 class="text-over">{{ corp.jobName }}</h1>
              <p class="text-over"><small>직무</small> {{ formatJob(corp.job) }}</p>
              <p class="text-over"><small>경력</small> {{ corp.jobExperience || '' }}</p>
              <p class="text-over"><small>근무지역</small>
                <span v-if="corp.workArea1">{{ corp.workArea1 || '' }} {{ corp.workArea2 || '' }}</span>
                <span v-else-if="corp.workHomeYn === 'Y'">재택가능</span>
                <span v-else>-</span>
              </p>
              <div class="state-box">
                <span :class="{'state01': corp.jobNoticeStateGb === '01', 'state02': corp.jobNoticeStateGb === '03'}">{{ $gbNameKR('JOB_NOTICE_STATE_GB', corp.jobNoticeStateGb) }}</span>
                <p class="text-over">{{ $yyyymmdd(corp.recruitStartYmd) }} ~ {{ $yyyymmdd(corp.recruitEndYmd) || '' }}</p>
              </div>
              <div v-if="user.userGb === 'STUDENT'">
                <KSATextButtonStop :text="corp.interestNoticeYn === 'Y' ? '♥' : '♡'" class="red_button" @click="onClickInterestNotice(corp)"/>
              </div>
            </dd>
          </dl>
        </div>
        <Paginate
          v-if="list.length > 0"
          v-model="currentPage"
          :page-count="totalPages"
          :click-handler="onSelectPage"
        />
      </div>
      <div v-else class="lecture-none text-center">
        등록된 채용공고가 없습니다.
      </div>
    </div>
  </div>
  <JobFairJobNoticeDetailModal ref="jobNoticeModal" /> <!-- 채용공고 보기 -->
</template>


<style lang="scss" scoped>
@import "../../../../assets/scss/theme";
.process-steps {
  .step {
    &:nth-child(5) {
      position: relative;
      &:before {
        content: "인재 회원";
        position: absolute;
        top: -8px;
        z-index: 1;
        color: #fff;
        font-size: 14px;
      }
      &:after {
        content: "";
        position: absolute;
        display: block;
        background: #4e4c4c;
        width: 80px;
        height: 30px;
        border-radius: 10px;
        top: -12px;
      }
    }
  }
}

.corp-wrap {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 21px;
  dl {
    flex: 1 1 calc(25% - 22px);
    max-width: calc(25% - 16px);
    height: 280px;
    border: 1px solid $gray-regular_color;
    border-radius: 6px;
    padding: 16px;
    cursor: pointer;
    dt {
      width: 100%;
      height: 70px;
      border: 1px solid $gray-regular_color;
    }
    dd {
      position: relative;
      margin-top: 10px;
      .text-over {
        display: block;
        max-width: calc(100% - 20px);
      }
      h1 {
        font-size: 18px;
      }
      p {
        small {
          display: inline-block;
          width: 64px;
          font-size: 14px;
          color: $gray-color;
        }
        &.link {
          color: $blue_color;
        }
        &:first-child {
          max-width: calc(100% - 30px);
        }
        &:last-of-type {
          font-size: 14px;
        }
      }
      h1 {
        max-width: calc(100% - 30px);
      }
      .state-box {
        display: flex;
        align-items: center;
        margin-top: 10px;
        span {
          display: inline-block;
          width: 80px;
          text-align: center;
          background-color: $blue_color;
          color: #fff;
          font-size: 14px;
          border-radius: 8px;
          padding: 6px 0;
          margin-right: 10px;
          &.state01 { // 채용대기
            color: $blue_color;
            border: 1px solid $blue_color;
            background: transparent;
          }
          &.state02 {
            background: $gray_color;
            color: #ffffff80;
          }
        }
      }
      button {
        position: absolute;
        top: 0;
        right: 0;
        font-size: 20px;
      }
    }
  }
}

.info-box {
  display: flex;
  background: $gray-light_color;
  justify-content: center;
  align-items: center;
  gap: 32px;
  margin-block: 16px;
  padding: 16px;
}

.filter-wrap>.filter>dl>dd.majorGb {
  padding-right: 100px;
  display: flex;
  flex-wrap: wrap;
}
</style>

